import hero2 from "../../assets/images/hero2.png"
import React, { useEffect, useState } from 'react';

import { sendContactMessage } from '../../services/api';
import { useLocation } from 'react-router-dom';

const ContactSection = () => {
  const location = useLocation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    grade: '',
  });

  const [availableGrades, setAvailableGrades] = useState([
    "7", "8", "9", "10", "11", "12"
  ]);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  // 🔁 Tự động điền subject nếu có từ location.state hoặc sessionStorage
  useEffect(() => {
    const contactEl = document.getElementById("contact");
    if (location.state?.scrollToContact && contactEl) {
      contactEl.scrollIntoView({ behavior: "smooth" });
    }

    if (location.state?.subjectText) {
      setFormData(prev => ({ ...prev, subject: location.state.subjectText }));
    }

    if (location.state?.teacherGrades) {
      setAvailableGrades(location.state.teacherGrades.map(String));
    }

  }, [location.state]);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      await sendContactMessage({
        name: formData.name,
        email: formData.email,
        grade: formData.grade,
        message: `📞 Số điện thoại: ${formData.phone}\n📘 Môn học quan tâm: ${formData.subject}`,
      });

      setMessage('🎉 Gửi đăng ký thành công!');
      setFormData({ name: '', email: '', phone: '', subject: '' , grade: ''});
    } catch (err) {
      setMessage('❌ Gửi không thành công. Vui lòng thử lại sau.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-20 bg-gray-50" id="contact">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden">
              <img
                src={hero2}
                alt="Student learning online"
                className="w-full h-auto"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.parentElement.innerHTML = `
                    <div className="w-full h-[400px] bg-gray-200 flex items-center justify-center">
                      <span className="text-gray-400">Student learning image</span>
                    </div>
                  `;
                }}
              />
            </div>
          </div>

          {/* Form */}
          <div>
            <h2 className="text-4xl font-bold mb-2">
              <span className="text-blue-900">Liên Hệ Chúng Tôi</span>{' '}
              <span className="text-primary-600">Tại Đây</span>
            </h2>
            <p className="text-gray-600 mb-8">
              Đăng ký ngay để trải nghiệm chất lượng giảng dạy của Nam Kiến Văn Education
            </p>

            <form className="space-y-4" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Họ tên"
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-500"
              />

              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Số điện thoại"
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-500"
              />

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Địa chỉ email"
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-500"
              />

              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Bạn muốn học với giáo viên nào? (Môn có thể vào mục Giáo Viên xem chi tiết)"
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
              {/* Grade Dropdown */}
              <select
                name="grade"
                value={formData.grade}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-500"
              >
                <option value="" disabled>Chọn khối lớp</option>
                {availableGrades.map((grade) => (
                  <option key={grade} value={grade}>Khối {grade}</option>
                ))}
              </select>

              <button type="submit" disabled={loading} className="w-full btn btn-primary py-3">
                {loading ? 'Đang gửi...' : 'Gửi'}
              </button>

              {message && (
                <p className="text-sm text-center mt-4 text-gray-700">
                  {message}
                </p>
              )}
            </form>


          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
